import React, { useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'
import './sharedUploadDialog.css'

export default function SharedUploadDialog({open,scope,busy,onClose,children,selectionOnly=false}) {
 const dialog=useRef(null)
 useEffect(()=>{
  if(!open)return
  const previous=document.activeElement,overflow=document.body.style.overflow
  document.body.style.overflow='hidden'
  dialog.current?.showModal()
  return ()=>{dialog.current?.close();document.body.style.overflow=overflow;previous?.focus()}
 },[open])
 if(!open)return children
 return createPortal(<dialog ref={dialog} className="shared-upload-dialog" aria-labelledby="shared-upload-title" onCancel={e=>{e.preventDefault();if(!busy)onClose()}}>
  <div className="shared-upload-heading"><div><h2 id="shared-upload-title">{selectionOnly?(scope==='all'?'All locations':'Select locations'):(scope==='all'?'Upload for all locations':'Upload for selected locations')}</h2><p>Choose where this document applies.</p></div><button type="button" disabled={busy} onClick={onClose}>Cancel</button></div>
  {children}
 </dialog>,document.body)
}
